import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { AuthedApi } from "../authed-api";
import { FE_Bot } from "../../models/admin-responses";
import { environment } from "../../../../environments/environment";
import { FE_WellknownConfigResponse } from "../../models/dimension-responses";
import { LogService } from "@shared/services/log.service";

@Injectable()
export class AdminBotsApiService extends AuthedApi {
    private baseUrl = environment.auth_server?.base_url || '';
    constructor(http: HttpClient, private readonly logService: LogService) {
        super(http);
        this.authedGet<FE_WellknownConfigResponse>("/.well-known/matrix/config").toPromise().then(res => {
            if (res?.authServerUrl) {
                this.baseUrl = res.authServerUrl;
            }
        }).catch( err => {
            this.logService.error(err);
        });
    }

    /**
     * Search bot by share key
     * @param key
     */
    public searchBot(key: string): Promise<FE_Bot> {
        return this.authedGet<FE_Bot>(this.baseUrl + `/share/bot/${key}` ).toPromise();
    }
}
